<template>
    <div class="room dehumidifier-small" v-loading="loadingData">
      <div class="device-block-multi">
        <div class="air-wrap" :class="warningFlag1">
          <div class="air-title">
            <span class="air-title-name">L1测点</span>
            <div class="air-switch-container-long">
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleVentFail" :series="switchDataVentFail" :smallBtn="true"></SwitchStatus>
                <SwitchStatus class="air-switch-item" :title="switchTitleVent" :series="switchDataVent" :smallBtn="true"></SwitchStatus>
                <SwitchStatus class="air-switch-item" :title="switchTitleVent1" :series="switchDataVent1" :smallBtn="true"></SwitchStatus>
              </div>
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleNewFail" :series="switchDataNewFail" :smallBtn="true"></SwitchStatus>
                <SwitchStatus class="air-switch-item" :title="switchTitleNew" :series="switchDataNew" :smallBtn="true"></SwitchStatus>
                <SwitchStatus class="air-switch-item" :title="switchTitleNew1" :series="switchDataNew1" :smallBtn="true"></SwitchStatus>
              </div>
            </div>
          </div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData11"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData12"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData13"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts4" :series="singleHisData14"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts5" :series="singleHisData15"></single-histogram>
            </div>
            <div class="air-chart-pie">
              <SinglePieHistogramWrap :opts="singlePieHisOpts" :series="singlePieHisData1"></SinglePieHistogramWrap>
            </div>
          </div>
        </div>
  
        <div class="air-wrap" :class="warningFlag2">
          <div class="air-title">
            <span class="air-title-name">L2测点</span>
            <div class="air-switch-container">
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleVent2" :series="switchDataVent2" :smallBtn="true"></SwitchStatus>
              </div>
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleNew2" :series="switchDataNew2" :smallBtn="true"></SwitchStatus>
              </div>
            </div>
          </div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData21"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData22"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData23"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts4" :series="singleHisData24"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts5" :series="singleHisData25"></single-histogram>
            </div>
            <div class="air-chart-pie">
              <SinglePieHistogramWrap :opts="singlePieHisOpts" :series="singlePieHisData2"></SinglePieHistogramWrap>
            </div>
          </div>
        </div>
      </div>
  
      <div class="device-block-multi">
        <div class="air-wrap" :class="warningFlag3">
          <div class="air-title">
            <span class="air-title-name">L3测点</span>
            <div class="air-switch-container">
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleVent3" :series="switchDataVent3" :smallBtn="true"></SwitchStatus>
              </div>
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleNew3" :series="switchDataNew3" :smallBtn="true"></SwitchStatus>
              </div>
            </div>
          </div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData31"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData32"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData33"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts4" :series="singleHisData34"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts5" :series="singleHisData35"></single-histogram>
            </div>
            <div class="air-chart-pie">
              <SinglePieHistogramWrap :opts="singlePieHisOpts" :series="singlePieHisData3"></SinglePieHistogramWrap>
            </div>
          </div>
        </div>
  
        <div class="air-wrap" :class="warningFlag4">
          <div class="air-title">
            <span class="air-title-name">L4测点</span>
            <div class="air-switch-container">
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleVent4" :series="switchDataVent4" :smallBtn="true"></SwitchStatus>
              </div>
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleNew4" :series="switchDataNew4" :smallBtn="true"></SwitchStatus>
              </div>
            </div>
          </div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData41"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData42"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData43"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts4" :series="singleHisData44"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts5" :series="singleHisData45"></single-histogram>
            </div>
            <div class="air-chart-pie">
              <SinglePieHistogramWrap :opts="singlePieHisOpts" :series="singlePieHisData4"></SinglePieHistogramWrap>
            </div>
          </div>
        </div>
      </div>
  
      <div class="device-block-multi">
        <div class="air-wrap" :class="warningFlag5">
          <div class="air-title">
            <span class="air-title-name">L5测点</span>
            <div class="air-switch-container">
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleVent5" :series="switchDataVent5" :smallBtn="true"></SwitchStatus>
              </div>
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleNew5" :series="switchDataNew5" :smallBtn="true"></SwitchStatus>
              </div>
            </div>
          </div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData51"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData52"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData53"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts4" :series="singleHisData54"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts5" :series="singleHisData55"></single-histogram>
            </div>
            <div class="air-chart-pie">
              <SinglePieHistogramWrap :opts="singlePieHisOpts" :series="singlePieHisData5"></SinglePieHistogramWrap>
            </div>
          </div>
        </div>
  
        <div class="air-wrap" :class="warningFlag6">
          <div class="air-title">
            <span class="air-title-name">L6测点</span>
            <div class="air-switch-container">
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleVent6" :series="switchDataVent6" :smallBtn="true"></SwitchStatus>
              </div>
              <div class="air-switch-line">
                <SwitchStatus class="air-switch-item" :title="switchTitleNew6" :series="switchDataNew6" :smallBtn="true"></SwitchStatus>
              </div>
            </div>
          </div>
          <div class="air-chart-wrap">
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts1" :series="singleHisData61"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts2" :series="singleHisData62"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts3" :series="singleHisData63"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts4" :series="singleHisData64"></single-histogram>
            </div>
            <div class="air-chart">
              <single-histogram :opts="singleHisOpts5" :series="singleHisData65"></single-histogram>
            </div>
            <div class="air-chart-pie">
              <SinglePieHistogramWrap :opts="singlePieHisOpts" :series="singlePieHisData6"></SinglePieHistogramWrap>
            </div>
          </div>
        </div>
      </div>
  
      <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    </div>
  </template>
    
    <script>
  import { isInEmphasis } from "echarts/lib/util/graphic";
  import configJson from "./config/steelboxConfig.json";
  
  export default {
    name: "tower",
    data() {
      return {
        timer: null,
        loading: false,
        loadingData: false,
        stationId: "",
        stationName: "",
        deviceList: [],
  
        singleHisData11: {},
        singleHisData12: {},
        singleHisData13: {},
        singleHisData14: {},
        singleHisData15: {},
  
        singleHisData21: {},
        singleHisData22: {},
        singleHisData23: {},
        singleHisData24: {},
        singleHisData25: {},
  
        singleHisData31: {},
        singleHisData32: {},
        singleHisData33: {},
        singleHisData34: {},
        singleHisData35: {},
  
        singleHisData41: {},
        singleHisData42: {},
        singleHisData43: {},
        singleHisData44: {},
        singleHisData45: {},
  
        singleHisData51: {},
        singleHisData52: {},
        singleHisData53: {},
        singleHisData54: {},
        singleHisData55: {},
  
        singleHisData61: {},
        singleHisData62: {},
        singleHisData63: {},
        singleHisData64: {},
        singleHisData65: {},
  
        singlePieHisData1: {},
        singlePieHisData2: {},
        singlePieHisData3: {},
        singlePieHisData4: {},
        singlePieHisData5: {},
        singlePieHisData6: {},
  
        warningFlag1: "",
        warningFlag2: "",
        warningFlag3: "",
        warningFlag4: "",
        warningFlag5: "",
        warningFlag6: "",
  
        switchDataVent: null,
        switchDataVentFail: null,
        switchDataNew: null,
        switchDataNewFail: null,
  
        switchDataVent1: null,
        switchDataNew1: null,
        switchDataVent2: null,
        switchDataNew2: null,
        switchDataVent3: null,
        switchDataNew3: null,
        switchDataVent4: null,
        switchDataNew4: null,
        switchDataVent5: null,
        switchDataNew5: null,
        switchDataVent6: null,
        switchDataNew6: null,
  
        singleHisOpts1: { title: "CH2O", histogramName1: "ug/m³", max: 5000 },
        singleHisOpts2: { title: "CO", histogramName1: "mg/m³", max: 10 },
        singleHisOpts3: { title: "O2", histogramName1: "%VOL", max: 50 },
        singleHisOpts4: { title: "PM2.5", histogramName1: "ug/m³", max: 10 },
        singleHisOpts5: { title: "VOC", histogramName1: "mg/m³", max: 10 },
      };
    },
    computed: {
      singlePieHisOpts: function () {
        return {
          title: "",
          histogramName1: "T",
          center1: ["52%", "60%"],
          radius1: ["40%", "55%"],
          pieName1: "RH",
          max: 50,
          pieMax: 100,
          toprichFontSize: 18,
          topFontSize: 20,
          sign: "°C",
        };
      },
      switchTitleVent: function () {
        return "排风运行";
      },
      switchTitleVentFail: function () {
        return "排风报警";
      },
      switchTitleNew: function () {
        return "新风运行";
      },
      switchTitleNewFail: function () {
        return "新风报警";
      },
      switchTitleVent1: function () {
        return "排风阀1";
      },
      switchTitleNew1: function () {
        return "新风阀1";
      },
      switchTitleVent2: function () {
        return "排风阀2";
      },
      switchTitleNew2: function () {
        return "新风阀2";
      },
      switchTitleVent3: function () {
        return "排风阀3";
      },
      switchTitleNew3: function () {
        return "新风阀3";
      },
      switchTitleVent4: function () {
        return "排风阀4";
      },
      switchTitleNew4: function () {
        return "新风阀4";
      },
      switchTitleVent5: function () {
        return "排风阀5";
      },
      switchTitleNew5: function () {
        return "新风阀5";
      },
      switchTitleVent6: function () {
        return "排风阀6";
      },
      switchTitleNew6: function () {
        return "新风阀6";
      },
    },
    created() {
      this.readConfig();
    },
    mounted() {
      this.getData();
      this.timer = setInterval(() => {
        this.getData();
      }, this.REFRESH_SECOND);
    },
    watch: {
      /**
       * 监听路由变化
       * @param {Object} route # 当前路由信息
       */
      $route(route) {
        this.resetData();
        this.readConfig();
        this.loadingData = true;
        this.getData();
      },
    },
    methods: {
      resetData() {
        this.warningFlag1 = "";
        this.warningFlag2 = "";
        this.warningFlag3 = "";
        this.warningFlag4 = "";
        this.warningFlag5 = "";
        this.warningFlag6 = "";
      },
      refreshData() {
        this.loadingData = true;
        this.getData();
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          this.getData();
        }, this.REFRESH_SECOND);
      },
      readConfig() {
        const routerPath = this.$route.fullPath.split("/");
      //  const routerName = routerPath[3].toLowerCase();
        const routerName = 'southtower';
        this.deviceList = configJson[routerName].deviceList;
        this.stationName = configJson[routerName].stationName;
        this.stationId = configJson[routerName].stationId;
      },
      findDeviceId(deviceName) {
        const device = this.deviceList.find((el) => {
          return el.deviceName === deviceName;
        });
        if (!device) {
          console.log(`deviceName${deviceName}###`);
        }
        return device.deviceId || "";
      },
      getStatisticsData(deviceId) {
        return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
      },
      getCurrentData(stationId) {
        return this.$http.get(`/deviceData/Station?stationId=${stationId}`);
      },
      getData() {
        this.getCurrentData(this.stationId).then((res) => {
          setTimeout(() => {
            this.loadingData = false;
          }, 500);
  
          const currentData = res.data;
  
          this.setSingleHistogramDataAndError(currentData, "singleHisData11", "L1测点" + this.singleHisOpts1.title, this.warningFlag1);
          this.setSingleHistogramDataAndError(currentData, "singleHisData12", "L1测点" + this.singleHisOpts2.title, this.warningFlag1);
          this.setSingleHistogramDataAndError(currentData, "singleHisData13", "L1测点" + this.singleHisOpts3.title, this.warningFlag1);
          this.setSingleHistogramDataAndError(currentData, "singleHisData14", "L1测点" + this.singleHisOpts4.title, this.warningFlag1);
          this.setSingleHistogramDataAndError(currentData, "singleHisData15", "L1测点" + this.singleHisOpts5.title, this.warningFlag1);
  
          this.setSingleHistogramDataAndError(currentData, "singleHisData21", "L2测点" + this.singleHisOpts1.title, this.warningFlag2);
          this.setSingleHistogramDataAndError(currentData, "singleHisData22", "L2测点" + this.singleHisOpts2.title, this.warningFlag2);
          this.setSingleHistogramDataAndError(currentData, "singleHisData23", "L2测点" + this.singleHisOpts3.title, this.warningFlag2);
          this.setSingleHistogramDataAndError(currentData, "singleHisData24", "L2测点" + this.singleHisOpts4.title, this.warningFlag2);
          this.setSingleHistogramDataAndError(currentData, "singleHisData25", "L2测点" + this.singleHisOpts5.title, this.warningFlag2);
  
          this.setSingleHistogramDataAndError(currentData, "singleHisData31", "L3测点" + this.singleHisOpts1.title, this.warningFlag3);
          this.setSingleHistogramDataAndError(currentData, "singleHisData32", "L3测点" + this.singleHisOpts2.title, this.warningFlag3);
          this.setSingleHistogramDataAndError(currentData, "singleHisData33", "L3测点" + this.singleHisOpts3.title, this.warningFlag3);
          this.setSingleHistogramDataAndError(currentData, "singleHisData34", "L3测点" + this.singleHisOpts4.title, this.warningFlag3);
          this.setSingleHistogramDataAndError(currentData, "singleHisData35", "L3测点" + this.singleHisOpts5.title, this.warningFlag3);
  
          this.setSingleHistogramDataAndError(currentData, "singleHisData41", "L4测点" + this.singleHisOpts1.title, this.warningFlag4);
          this.setSingleHistogramDataAndError(currentData, "singleHisData42", "L4测点" + this.singleHisOpts2.title, this.warningFlag4);
          this.setSingleHistogramDataAndError(currentData, "singleHisData43", "L4测点" + this.singleHisOpts3.title, this.warningFlag4);
          this.setSingleHistogramDataAndError(currentData, "singleHisData44", "L4测点" + this.singleHisOpts4.title, this.warningFlag4);
          this.setSingleHistogramDataAndError(currentData, "singleHisData45", "L4测点" + this.singleHisOpts5.title, this.warningFlag4);
  
          this.setSingleHistogramDataAndError(currentData, "singleHisData51", "L5测点" + this.singleHisOpts1.title, this.warningFlag5);
          this.setSingleHistogramDataAndError(currentData, "singleHisData52", "L5测点" + this.singleHisOpts2.title, this.warningFlag5);
          this.setSingleHistogramDataAndError(currentData, "singleHisData53", "L5测点" + this.singleHisOpts3.title, this.warningFlag5);
          this.setSingleHistogramDataAndError(currentData, "singleHisData54", "L5测点" + this.singleHisOpts4.title, this.warningFlag5);
          this.setSingleHistogramDataAndError(currentData, "singleHisData55", "L5测点" + this.singleHisOpts5.title, this.warningFlag5);
  
          this.setSingleHistogramDataAndError(currentData, "singleHisData61", "L6测点" + this.singleHisOpts1.title, this.warningFlag6);
          this.setSingleHistogramDataAndError(currentData, "singleHisData62", "L6测点" + this.singleHisOpts2.title, this.warningFlag6);
          this.setSingleHistogramDataAndError(currentData, "singleHisData63", "L6测点" + this.singleHisOpts3.title, this.warningFlag6);
          this.setSingleHistogramDataAndError(currentData, "singleHisData64", "L6测点" + this.singleHisOpts4.title, this.warningFlag6);
          this.setSingleHistogramDataAndError(currentData, "singleHisData65", "L6测点" + this.singleHisOpts5.title, this.warningFlag6);
  
          this.setPieHistogramDataAndError(currentData, "singlePieHisData1", "L1测点温度", "L1测点湿度", "warningFlag1");
          this.setPieHistogramDataAndError(currentData, "singlePieHisData2", "L2测点温度", "L2测点湿度", "warningFlag2");
          this.setPieHistogramDataAndError(currentData, "singlePieHisData3", "L3测点温度", "L3测点湿度", "warningFlag3");
          this.setPieHistogramDataAndError(currentData, "singlePieHisData4", "L4测点温度", "L4测点湿度", "warningFlag4");
          this.setPieHistogramDataAndError(currentData, "singlePieHisData5", "L5测点温度", "L5测点湿度", "warningFlag5");
          this.setPieHistogramDataAndError(currentData, "singlePieHisData6", "L6测点温度", "L6测点湿度", "warningFlag6");
  
          const switchIdVent = this.findDeviceId(this.switchTitleVent.replace("运行", "电机状态"));
          const switchIdVentFail = this.findDeviceId(this.switchTitleVentFail.replace("报警", "电机失电报警"));
          const switchIdNew = this.findDeviceId(this.switchTitleNew.replace("运行", "电机状态"));
          const switchIdNewFail = this.findDeviceId(this.switchTitleNewFail.replace("报警", "电机失电报警"));
          this.switchDataVent = {
            data: currentData[switchIdVent].value,
            isError: currentData[switchIdVent].errorLevel,
          };
          this.switchDataVentFail = {
            data: currentData[switchIdVentFail].value,
            isError: currentData[switchIdVentFail].errorLevel,
            isZh: true,
          };
          this.switchDataNew = {
            data: currentData[switchIdNew].value,
            isError: currentData[switchIdNew].errorLevel,
          };
          this.switchDataNewFail = {
            data: currentData[switchIdNewFail].value,
            isError: currentData[switchIdNewFail].errorLevel,
            isZh: true,
          };
  
          const switchIdVent1 = this.findDeviceId(this.switchTitleVent1 + "开关");
          const switchIdVent2 = this.findDeviceId(this.switchTitleVent2 + "开关");
          const switchIdVent3 = this.findDeviceId(this.switchTitleVent3 + "开关");
          const switchIdVent4 = this.findDeviceId(this.switchTitleVent4 + "开关");
          const switchIdVent5 = this.findDeviceId(this.switchTitleVent5 + "开关");
          const switchIdVent6 = this.findDeviceId(this.switchTitleVent6 + "开关");
          this.switchDataVent1 = {
            data: currentData[switchIdVent1].value,
            isError: currentData[switchIdVent1].errorLevel,
          };
          this.switchDataVent2 = {
            data: currentData[switchIdVent2].value,
            isError: currentData[switchIdVent2].errorLevel,
          };
          this.switchDataVent3 = {
            data: currentData[switchIdVent3].value,
            isError: currentData[switchIdVent3].errorLevel,
          };
          this.switchDataVent4 = {
            data: currentData[switchIdVent4].value,
            isError: currentData[switchIdVent4].errorLevel,
          };
          this.switchDataVent5 = {
            data: currentData[switchIdVent5].value,
            isError: currentData[switchIdVent5].errorLevel,
          };
          this.switchDataVent6 = {
            data: currentData[switchIdVent6].value,
            isError: currentData[switchIdVent6].errorLevel,
          };
  
          const switchIdNew1 = this.findDeviceId(this.switchTitleNew1 + "开关");
          const switchIdNew2 = this.findDeviceId(this.switchTitleNew2 + "开关");
          const switchIdNew3 = this.findDeviceId(this.switchTitleNew3 + "开关");
          const switchIdNew4 = this.findDeviceId(this.switchTitleNew4 + "开关");
          const switchIdNew5 = this.findDeviceId(this.switchTitleNew5 + "开关");
          const switchIdNew6 = this.findDeviceId(this.switchTitleNew6 + "开关");
          this.switchDataNew1 = {
            data: currentData[switchIdNew1].value,
            isError: currentData[switchIdNew1].errorLevel,
          };
          this.switchDataNew2 = {
            data: currentData[switchIdNew2].value,
            isError: currentData[switchIdNew2].errorLevel,
          };
          this.switchDataNew3 = {
            data: currentData[switchIdNew3].value,
            isError: currentData[switchIdNew3].errorLevel,
          };
          this.switchDataNew4 = {
            data: currentData[switchIdNew4].value,
            isError: currentData[switchIdNew4].errorLevel,
          };
          this.switchDataNew5 = {
            data: currentData[switchIdNew5].value,
            isError: currentData[switchIdNew5].errorLevel,
          };
          this.switchDataNew6 = {
            data: currentData[switchIdNew6].value,
            isError: currentData[switchIdNew6].errorLevel,
          };
        });
      },
      setSingleHistogramDataAndError(currentData, echartSeriesDataName, deviceName, warningFlagName) {
        const deviceId = this.findDeviceId(deviceName);
        this[echartSeriesDataName] = {
          data: currentData[deviceId].value,
        };
  
        let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[deviceId].errorLevel, this[warningFlagName]);
        this[warningFlagName] = errorLevel;
      },
      setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
        const temperatureId = this.findDeviceId(temperatureName);
        const humidityId = this.findDeviceId(humidityName);
        this[echartSeriesDataName] = {
          data1: currentData[temperatureId].value,
          data2: currentData[humidityId].value,
        };
  
        let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
        errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
        this[warningFlagName] = errorLevel;
      },
      getLineChartData() {
        let temperatureDeviceName = "除湿机温度";
        let humidityDeviceName = "除湿机湿度";
        this.$http
          .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceName)), this.getStatisticsData(this.findDeviceId(humidityDeviceName))])
          .then(
            this.$http.spread((temperaturePromise, humidityPromise) => {
              this.setLineData(temperaturePromise, humidityPromise, "humidityLineData", "warningFlagLeft");
            })
          );
      },
      setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
        let data1 = {};
        let data2 = {};
        temperatureData.data.dataList.forEach((item, index) => {
          data1[item.StatisticsDate] = item.value;
        });
        humidityData.data.dataList.forEach((item, index) => {
          data2[item.StatisticsDate] = item.value;
        });
  
        this[echartSeriesDataName] = {
          data1: data1,
          data2: data2,
        };
  
        let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
        errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
        this[warningFlagName] = errorLevel;
      },
      getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
        if (currentErrorLevel === "Error") {
          return "Error";
        } else if (currentErrorLevel === "Warning") {
          if (newErrorLevel === "Error") {
            return "Error";
          } else {
            return "Warning";
          }
        } else {
          return newErrorLevel;
        }
      },
    },
  };
  </script>
    
    <style lang="scss" scoped>
  .dehumidifier-small {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: stretch;
    padding-top: 10px;
  
    .device-block-multi {
      width: 100%;
      height: calc(33% - 10px);
      background-color: transparent;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
  
      .device-block {
        width: calc(50% - 10px);
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        position: relative;
  
        .device-block-line-chart {
          width: 75%;
          height: 100%;
        }
  
        .device-block-bar-chart {
          width: 24%;
          height: 100%;
        }
      }
  
      .device-block-multi-item {
        background-color: rgba(255, 255, 255, 0.6);
        width: calc((100% / 4) - 10px);
      }
  
      .device-block-line-item {
        width: calc(50% - 10px);
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        align-items: stretch;
  
        .device-block-line-item-top {
          display: flex;
          justify-content: space-between;
          height: 140px;
          width: 100%;
        }
  
        .device-block-line-item-half {
          display: flex;
          height: 100%;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
  
        .switch-item {
          height: 38px;
          width: 100%;
          box-sizing: border-box;
          margin-bottom: 10px;
          flex-shrink: 0;
          &:last-child {
            margin-bottom: 0;
          }
        }
  
        .device-block-time-left {
          height: calc(100% - 190px);
          width: 100%;
          box-sizing: border-box;
        }
  
        .device-block-time-right {
          height: calc(100% - 140px);
          width: 100%;
          box-sizing: border-box;
        }
      }
    }
  
    .device-block-line {
      width: 100%;
      height: calc(50% - 15px);
      background-color: transparent;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
  
      .device-block-line-item {
        width: calc(50% - 10px);
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        flex-direction: column;
        align-items: stretch;
  
        .device-block-line-item-top {
          display: flex;
          justify-content: space-between;
          height: 140px;
          width: 100%;
        }
  
        .device-block-line-item-half {
          display: flex;
          height: 100%;
          width: calc(50% - 7px);
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
  
    .air-wrap {
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: column;
      padding: 0 10px;
      width: calc(50% - 10px);
      height: 100%;
      background-color: rgba(255, 255, 255, 0.6);
      box-sizing: border-box;
  
      .air-title {
        display: flex;
        justify-content: space-between;
        height: 50px;
      }
  
      .air-title-name {
        padding: 20px 15px 10px 10px;
        font-size: 22px;
        color: #515151;
      }
  
      .air-switch-container-long {
        display: flex;
        flex-direction: column;
        margin-top: 5px;
  
        height: 65px;
        width: 430px;
      }
  
      .air-switch-container {
        display: flex;
        flex-direction: column;
        margin-top: 5px;
  
        height: 65px;
        width: 140px;
      }
  
      .air-switch-line {
        display: flex;
  
        height: 30px;
      }
  
      .air-switch-item {
        height: 20px;
        width: 140px;
        box-sizing: border-box;
        margin-bottom: 10px;
        flex-shrink: 0;
        background-color: transparent;
        &:last-child {
          margin-bottom: 0;
        }
      }
  
      .air-chart-wrap {
        display: flex;
        flex: 1;
      }
  
      .air-chart {
        padding-top: 10px;
        box-sizing: border-box;
        width: 33.3333%;
      }
  
      .air-chart-pie {
        padding-top: 3px;
        box-sizing: border-box;
        width: 33.3333%;
      }
    }
  }
  </style>
    